import { MY_SELL_STATUS, PAY_STATUS, SCAN_PAY_STATUS } from '@/constants/status';

import request from './index';

export type DepositInfo = {
  merchant_order_id: string;
  web_status: (typeof PAY_STATUS)[keyof typeof PAY_STATUS];
  app_code: string;
  amount: number;
  bank_name: string;
  card_number: string;
  card_holder: string;
  ifsc_code: string;
  is_qr: boolean;
  qr_code: string;
  transfer_deadline: string;
  created_time: string;
  merchant_cs_url: string;
};

/** 取得搶單 - 訂單狀態 */
export const getDepositInfo = async (id: string): Promise<DepositInfo> => {
  try {
    const url = `/api/web/v1/deposit/revenue/${id}`;
    const response = await request(url);

    return response.data;
  } catch (error) {
    console.error('Error fetching deposit info:', error);
    throw error;
  }
};

/** 取消搶單訂單 */
export const cancelTransition = async (id: string) => {
  try {
    const url = `/api/web/v1/deposit/cancel/${id}`;
    const response = await request(url, {
      method: 'DELETE',
    });
    return response.data;
  } catch (error) {
    console.error('Error cancelling transition:', error);
    throw error;
  }
};

/** 上傳搶單付款證明 */
export const uploadPaymentProof = async (params: { id: string; image: string; name: string }) => {
  try {
    const url = `/api/web/v1/deposit/image`;
    const response = await request(url, {
      method: 'POST',
      body: JSON.stringify(params),
    });

    return response.data;
  } catch (error) {
    console.error('Error uploading payment proof:', error);
    throw error;
  }
};

export type ScanPayInfo = {
  merchant_order_id: string;
  web_status: (typeof SCAN_PAY_STATUS)[keyof typeof SCAN_PAY_STATUS];
  amount: number;
  merchant_member_name: string;
  qr_content: string;
  created_time: string;
  merchant_cs_url: string;
};

/** 取得掃碼支付 - 訂單狀態 */
export const getScanPayInfo = async (id: string): Promise<ScanPayInfo> => {
  try {
    const url = `/api/web/v1/scanPay/order/${id}`;
    const response = await request(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching scan pay info:', error);
    throw error;
  }
};

export type MySellInfo = {
  merchant_order_id: string;
  merchant_remark: string;
  web_status: (typeof MY_SELL_STATUS)[keyof typeof MY_SELL_STATUS];
  app_code: string;
  amount: number;
  bank_name: string;
  card_number: string;
  card_holder: string;
  ifsc_code: string;
  is_qr: boolean;
  qr_code: string;
  transfer_deadline: string;
  created_time: string;
  merchant_cs_url: string;
};

/** 取得我要賣 - 訂單狀態 */
export const getMySellInfo = async (id: string): Promise<MySellInfo> => {
  try {
    const url = `/api/web/v1/mysell/order/${id}`;
    const response = await request(url);

    return response.data;
  } catch (error) {
    console.error('Error fetching mysell info:', error);
    throw error;
  }
};

/** 取消我要賣訂單 */
export const cancelTransitionMySell = async (id: string) => {
  try {
    const url = `/api/web/v1/mysell/cancel/${id}`;
    const response = await request(url, {
      method: 'DELETE',
    });
    return response.data;
  } catch (error) {
    console.error('Error cancelling transition:', error);
    throw error;
  }
};

/** 上傳我要賣付款證明 */
export const uploadPaymentProofMySell = async (params: { id: string; image: string; name: string }) => {
  try {
    const url = `/api/web/v1/mysell/image`;
    const response = await request(url, {
      method: 'POST',
      body: JSON.stringify(params),
    });

    return response.data;
  } catch (error) {
    console.error('Error uploading payment proof:', error);
    throw error;
  }
};
